// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"u0-z","subtitle":"v0-z","wrapper":"w0-z","leftArrow":"x0-z","rightArrow":"y0-z"};